module.exports = __webpack_public_path__ + "img/gitlab.6ef6afd3.png";